import React from "react";
import { View, StyleSheet } from "react-native";

import colors from "@constants/color";
import Text from "@components/CustomText";

const Tag = ({
  text,
  bgcolor = "rgba(66, 116, 234, 1)",
  icon = null,
  textColor = colors.white,
  borderColor = null,
}) => {
  return (
    <View
      style={[
        styles.delayedTag,
        { backgroundColor: bgcolor },
        borderColor ? { borderWidth: 1, borderColor } : null,
      ]}
    >
      {icon ? <View style={styles.icon}>{icon}</View> : null}
      <Text
        variant="caption_1"
        numberOfLines={1}
        style={{ color: textColor, lineHeight: 18 }}
      >
        {text}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  delayedTag: {
    borderRadius: 18,
    paddingHorizontal: 8,
    paddingVertical: 1,
    flexDirection: "row",
    alignItems: "center",
    flexShrink: 0,
  },
  icon: {
    marginRight: 4,
  },
});

export default Tag;
